import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./ui/tooltip";
import { Wifi, WifiOff } from "lucide-react";

const COLORS = [
  "bg-indigo-500", "bg-emerald-500", "bg-amber-500", "bg-rose-500",
  "bg-cyan-500", "bg-violet-500", "bg-orange-500", "bg-teal-500",
];

const getColor = (name) => {
  let hash = 0;
  for (let i = 0; i < (name || "").length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return COLORS[Math.abs(hash) % COLORS.length];
};

export const PresenceBar = ({ onlineUsers = [], connected, currentUserId }) => {
  const others = onlineUsers.filter((u) => u.user_id !== currentUserId);

  return (
    <div className="flex items-center gap-1.5" data-testid="presence-bar">
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger>
            <div className={`w-2 h-2 rounded-full ${connected ? "bg-emerald-500" : "bg-slate-300"} animate-pulse`} />
          </TooltipTrigger>
          <TooltipContent>{connected ? "Connected" : "Reconnecting..."}</TooltipContent>
        </Tooltip>
      </TooltipProvider>

      {others.length > 0 && (
        <div className="flex items-center -space-x-1.5 ml-1">
          <TooltipProvider>
            {others.slice(0, 5).map((u) => (
              <Tooltip key={u.user_id}>
                <TooltipTrigger>
                  <div
                    className={`w-7 h-7 rounded-full flex items-center justify-center text-[10px] font-bold text-white ring-2 ring-white ${getColor(u.name)}`}
                    data-testid={`presence-avatar-${u.user_id}`}
                  >
                    {(u.name || "?")[0].toUpperCase()}
                  </div>
                </TooltipTrigger>
                <TooltipContent>
                  <div className="text-xs">
                    <div className="font-semibold">{u.name}</div>
                    {u.viewing_department && (
                      <div className="text-slate-400">Viewing: {u.viewing_department}</div>
                    )}
                  </div>
                </TooltipContent>
              </Tooltip>
            ))}
          </TooltipProvider>
          {others.length > 5 && (
            <div className="w-7 h-7 rounded-full flex items-center justify-center text-[10px] font-bold text-slate-600 bg-slate-200 ring-2 ring-white">
              +{others.length - 5}
            </div>
          )}
        </div>
      )}

      {connected ? (
        <Wifi className="w-3.5 h-3.5 text-emerald-500 ml-1" />
      ) : (
        <WifiOff className="w-3.5 h-3.5 text-slate-400 ml-1" />
      )}
    </div>
  );
};

export default PresenceBar;
